import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import deLocale from '@fullcalendar/core/locales/de';
import ExitButton from '../common/ExitButton';
import './Calendar.css';

// A Calendar component using FullCalendar

export default function Calendar({ events, onEventClick, onClick }) {

  const calendarEvents = events.map(ev => ({
    event: ev,
    title: ev.title,
    start: ev.startDate,
    end: ev.endDate    
  }));

  return (
    <div className="CalendarContainer">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '5px' }}>
        <ExitButton onClick={onClick} />
      </div>
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        locale={deLocale}
        weekends={true}
        events={calendarEvents}
        eventClick={(info) => {
          onEventClick(info.event.extendedProps.event);
        }}
        height="auto"
        headerToolbar={{
            right: 'title',
            left: 'prev,next'
        }}
      />
    </div>
  );
}